// extracted by mini-css-extract-plugin
export default {"font-renta":"InstructionPage_font-renta__uggVM","instruction":"InstructionPage_instruction__8Xb44","photoContainer":"InstructionPage_photoContainer__DAl4Y"};